import React from 'react';
import { cn } from '../../lib/utils';

const STATUS_STYLES = {
  connected:
    'bg-emerald-600/90 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] ring-1 ring-white/40 backdrop-blur-md',
  disconnected:
    'bg-rose-700 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.28)] ring-1 ring-white/35 backdrop-blur-md',
  error:
    'bg-rose-700 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.28)] ring-1 ring-white/35 backdrop-blur-md',
  syncing:
    'bg-sky-600/90 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.35)] ring-1 ring-white/40 backdrop-blur-md',
  coming_soon:
    'bg-amber-600 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.3)] ring-1 ring-white/40 backdrop-blur-md',
};

const STATUS_LABELS = {
  connected: 'Connected',
  disconnected: 'Not connected',
  error: 'Needs attention',
  syncing: 'Syncing',
  coming_soon: 'Coming soon',
};

export function IntegrationStatusBadge({ status, className }) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-[8px] font-semibold uppercase tracking-[0.1em]',
        STATUS_STYLES[status] || STATUS_STYLES.disconnected,
        className
      )}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
